import { validationMessages } from '../../utils/validationMessages';

const EventsFormModel = {
  personalDetailsFormField: {
    Title: {
      name: 'Title',
      label: 'Title*',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    FirstName: {
      name: 'FirstName',
      label: 'First name*',
      maxStringCount: 50,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    Surname: {
      name: 'Surname',
      label: 'Surname*',
      maxStringCount: 50,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    Email: {
      name: 'Email',
      label: 'Email*',
      maxStringCount: 100,
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    MobileNumber: {
      name: 'MobileNumber',
      label: 'Mobile number*',
      maxStringCount: 69,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    WorkplaceAddress: {
      name: 'WorkplaceAddress',
      label: 'Workplace address*',
      maxStringCount: 1000,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  },
  eventDetailsFormField: {
    AcademicDiscipline: {
      name: 'AcademicDiscipline',
      label: 'What Academic discipline are you applying to? *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    TitleOfActivity: {
      name: 'TitleOfActivity',
      label: 'Title of Activity (Event Name) *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    TypeOfActivity: {
      name: 'TypeOfActivity',
      label: 'Type of Activity *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    OtherTypeOfActivity: {
      name: 'OtherTypeOfActivity',
      label: 'Other Type of Activity *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    TypeOfActivityCode: {
      name: 'TypeOfActivityCode'
    },
    ExpectedNumberOfParticipants: {
      name: 'ExpectedNumberOfParticipants',
      label: 'Expected Number of Participants *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    IntendedAudience: {
      name: 'IntendedAudience',
      label: 'Intended Audience *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    EventStartDate: {
      name: 'EventStartDate',
      label: 'Event start date *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    EventCountry: {
      name: 'EventCountry',
      label: 'Event country *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    EventCounty: {
      name: 'EventCounty',
      label: 'Event county *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    EventVenue: {
      name: 'EventVenue',
      label: 'Event venue *',
      maxStringCount: 200,
      information_text: 'Provide the address where your activity will take place.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  },
  organiserDetailsFormField: {
    OrganiserType: {
      name: 'OrganiserType',
      label: 'Organiser type *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    OrganisingInstitutionType: {
      name: 'OrganisingInstitutionType',
      label: 'Organising Institution Type *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    OrganisingInstitutionOtherType: {
      name: 'OrganisingInstitutionOtherType',
      label: 'Other Organising Institution Type *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    OrganisingInstitution: {
      name: 'OrganisingInstitution',
      label: 'Organising institution *',
      maxStringCount: 200,
      information_text: 'The institution responsible for hosting the activity.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    LeadOrganiserFirstName: {
      name: 'LeadOrganiserFirstName',
      label: 'First name *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    LeadOrganiserSurname: {
      name: 'LeadOrganiserSurname',
      label: 'Surname *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    LeadOrganiserIMCNumber: {
      name: 'LeadOrganiserIMCNumber',
      label: 'IMC',
      maxStringCount: 6,
      information_text: 'Only display IMC No if Organiser Type = Surgical/ Medical Lead organiser.'
    },
    LeadOrganiserMobile: {
      name: 'LeadOrganiserMobile',
      label: 'Mobile *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    LeadOrganiserEmail: {
      name: 'LeadOrganiserEmail',
      label: 'Email *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    LeadOrganiserWorkplaceAddress: {
      name: 'LeadOrganiserWorkplaceAddress',
      label: 'Workplace address *',
      maxStringCount: 1000,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    AreYouEventOrganiser: {
      name: 'AreYouEventOrganiser',
      label: 'Are you the event organiser/administrator for this event? *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    AdministrationOrganiserDetailsFirstName: {
      name: 'AdministrationOrganiserDetailsFirstName',
      label: 'First name *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    AdministrationOrganiserSurname: {
      name: 'AdministrationOrganiserSurname',
      label: 'Surname *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    AdministrationOrganiserMobile: {
      name: 'AdministrationOrganiserMobile',
      label: 'Mobile *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    AdministrationOrganiserEmail: {
      name: 'AdministrationOrganiserEmail',
      label: 'Email *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    AdministrationOrganiserWorkplaceAddress: {
      name: 'AdministrationOrganiserWorkplaceAddress',
      label: 'Workplace address *',
      maxStringCount: 1000,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  },
  educationalAimsAndObjectivesDetailsFormField: {
    LearningObjectivesOfActivity: {
      name: 'LearningObjectivesOfActivity',
      label: 'What are the Learning objectives of this activity *',
      maxStringCount: 1000,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    SkillsKnowledgeAcquireDuringTheActivity: {
      name: 'SkillsKnowledgeAcquireDuringTheActivity',
      label: 'What specific skills / knowledge will participants acquire during the activity *',
      maxStringCount: 1000,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    LearningTeachingMethods: {
      name: 'LearningTeachingMethods',
      label: 'Which Learning/Teaching methods will be used *',
      information_text: 'Select one or more options that apply.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    OtherLearningTeachingMethods: {
      name: 'OtherLearningTeachingMethods',
      label: 'If learning/teaching method is other, please specify *',
      maxStringCount: 1000,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    EventEvaluation: {
      name: 'EventEvaluation',
      label: 'Please provide a description of evaluation methods to be used *',
      maxStringCount: 1000,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    MedicalCouncils8DomainsOfGoodProfessionalPractice: {
      name: 'MedicalCouncils8DomainsOfGoodProfessionalPractice',
      label: "Which of the Medical Council's 8 Domains of Good Professional Practice are addressed in the Educational Activity? *",
      information_text: 'Select one or more options that apply. Further information on the domains of good professional practice can be found on the website.',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    }
  },
  sponsorshipFormField: {
    EventSponsored: {
      name: 'EventSponsored',
      label: 'Is sponsorship sourced from an Industry Sponsor? *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    SponsorshipType: {
      name: 'SponsorshipType',
      label: 'Name of Sponsor/s *',
      maxStringCount: 500,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    RelationshipBetweenSponsorsAndTheSpeakers: {
      name: 'RelationshipBetweenSponsorsAndTheSpeakers',
      label: 'Please describe the relationship between the sponsor(s) and the speaker(s) *',
      maxStringCount: 100,
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    RegistrationFeeForAttendees: {
      name: 'RegistrationFeeForAttendees',
      label: 'Is there a registration fee for attendees for this event? *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    AmountForRegistrationFeeForAttendees: {
      name: 'AmountForRegistrationFeeForAttendees',
      label: 'Registration Fee Amount (in Euro) *',
      maxStringCount: 100,
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    }
  },
  calendarOfActivitiesFormField: {
    EventPublishedOnRcsiCalendarOfActivities: {
      name: 'EventPublishedOnRcsiCalendarOfActivities',
      label: 'Do you wish to have your event published on the PCS Calendar of Activities *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    EventWebsiteUrl: {
      name: 'EventWebsiteUrl',
      label: 'If yes, please supply URL of Event website',
      maxStringCount: 255,
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      }
    },
    EmailAddress: {
      name: 'EmailAddress',
      label: 'If yes, please supply a contact email address *',
      maxStringCount: 100,
      get typeError(): string {
        return validationMessages.invalid(this.label);
      },
      get maxStringLengthErrorMsg(): string {
        return validationMessages.maxLength(this.label, this.maxStringCount);
      },
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    },
    ApprovalToAnotherPostgraduateMedicalTrainingBody: {
      name: 'ApprovalToAnotherPostgraduateMedicalTrainingBody',
      label: 'Have you applied for approval to another postgraduate medical training body *',
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    }
  },
  documentFormField: {
    SupportingDocument: {
      name: 'SupportingDocument',
      label: 'Supporting document *',
      informationText: 'Please upload proof of attendance / cerificate',
      invalidFileTypeErrorMsg: validationMessages.invalidFileType('PDF, Text, Word, Excel, JPEG, GIF, PNG or Powerpoint'),
      invalidFileSizeErrorMsg: validationMessages.invalidFileSize(5),
      get fileNotUploaded(): string {
        return `${this.label.replace('*', '')} not uploaded.`;
      },
      get requiredErrorMsg(): string {
        return validationMessages.required(this.label);
      }
    }
  },
  declarationFormField: {
    LeadOrganiserNotEmployeeOfIndustrySponsor: {
      name: 'LeadOrganiserNotEmployeeOfIndustrySponsor',
      label: `The Lead Organiser is not an employee of an Industry sponsor.`
    },
    ProgrammeDevelopedByLeadOrganiser: {
      name: 'ProgrammeDevelopedByLeadOrganiser',
      label: `This programme was developed by the lead organiser and complies with all relevant ethical, 
        medico-legal, regulatory, and scientifically sound research.`
    },
    ContentOfAllAspectsOfEventWillBeFree: {
      name: 'ContentOfAllAspectsOfEventWillBeFree',
      label: 'The content of all aspects of the event will be free of any influence by Industry sponsors.'
    },
    AllRelevantFinancialRelationships: {
      name: 'AllRelevantFinancialRelationships',
      label: `All relevant financial relationships (Conflict of Interest forms) of planners, faculty, and 
        others who are in control of the educational content for this activity will be identified and mitigated 
        prior to activity taking place.`
    },
    DeclarationsOfConflictsOfInterest: {
      name: 'DeclarationsOfConflictsOfInterest',
      label: `Declarations of conflicts of interest, whether present or absent, will be formally documented and 
        disclosed to learners at the commencement of the activity.`
    },
    ParticipantsInThisActivityToProvide: {
      name: 'ParticipantsInThisActivityToProvide',
      label: `A means for participants in this activity to provide learner feedback will be available.`
    },
    AllParticipantsInWithClearEvidence: {
      name: 'AllParticipantsInThisActivityWillBeProvidedWithClearEvidenceOfParticipation',
      label: `All participants in this activity will be provided with clear evidence of participation.`
    },
    LearnersWillBeInformed: {
      name: 'LearnersWillBeInformed',
      label: `Learners will be informed of who is responsible for the accreditation of the activity and 
        number of credits awarded.  This should appear on all distributed activity materials and brochures.`
    },
    ApplicationConformsToTheRCSIGuidelines: {
      name: 'ApplicationConformsToTheRCSIGuidelines',
      label: `I declare that this application conforms to the RCSI Guidelines for Approval of Educational Events.`
    },
    BreachOfGuidelines: {
      name: 'BreachOfGuidelines',
      label: `I understand that a breach of any of the guidelines may constitute unprofessional behaviour and 
        may lead to sanctions.`
    }
  }
};

export default EventsFormModel;
